import Axios from "axios";
import {
    SET_ASSET_REGISTRATION_LIST,
    UNSET_ASSET_REGISTRATION_LIST,
    SET_EDITING_ASSET_REGISTRATION,
    UNSET_EDITING_ASSET_REGISTRATION,
    SET_VIEW_ASSET_REGISTRATION,
    UNSET_VIEW_ASSET_REGISTRATION
} from "@/store/mutation-types";

import { saveUpdateAssetRegistration, getAssetRegistrationsList, getAssetRegistrationById } from "@/store/api";

const state = {
    getAssetRegistrationsList: [],
    getEditingAssetRegistration: null,
    getViewingAssetRegistration: null,
};

const getters = {
    getAssetRegistrationsList(state) {
        return state.getAssetRegistrationsList;
    },
    getEditingAssetRegistration(state) {
        return state.getEditingAssetRegistration;
    },
    getViewingAssetRegistration(state) {
        return state.getViewingAssetRegistration;
    }
};

const mutations = {
    [SET_ASSET_REGISTRATION_LIST](state, data) {
        state.getAssetRegistrationsList = data;
    },
    [UNSET_ASSET_REGISTRATION_LIST](state) {
        state.getAssetRegistrationsList = [];
    },
    [SET_EDITING_ASSET_REGISTRATION](state, data) {
        state.getEditingAssetRegistration = data;
    },
    [UNSET_EDITING_ASSET_REGISTRATION](state) {
        state.getEditingAssetRegistration = null;
    },
    [SET_VIEW_ASSET_REGISTRATION](state, data) {
        state.getViewingAssetRegistration = data;
    },
    [UNSET_VIEW_ASSET_REGISTRATION](state) {
        state.getViewingAssetRegistration = null;
    }
};

const actions = {
    saveUpdateAssetRegistration({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetRegistration, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetRegistrationsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegistrationsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_REGISTRATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_REGISTRATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetRegistrationById({ commit }, data) {
        const getAssetRegistrationRecordById = `${getAssetRegistrationById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetRegistrationRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
